
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative h-[500px] bg-zinc-900 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4c18933fdddd8bbf41407e9fb18ea101.jpg"
          alt="The Border Burger Co."
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative h-full max-w-[1400px] mx-auto px-6">
        <div className="flex items-end h-full pb-12">
          <div className="flex-1">
            <div className="mb-4">
              <nav className="flex items-center gap-2 text-sm">
                <Link
                  to="/"
                  className="text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Juarez, Mexico
                </Link>
                <i className="ri-arrow-right-s-line text-white/50"></i>
                <Link
                  to="/juarez-mexico-city-guide"
                  className="text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  City Guide
                </Link>
                <i className="ri-arrow-right-s-line text-white/50"></i>
                <Link
                  to="/places-to-eat"
                  className="text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Dining
                </Link>
                <i className="ri-arrow-right-s-line text-white/50"></i>
                <span className="text-white font-medium">The Border Burger Co.</span>
              </nav>
            </div>

            <h1 className="text-5xl font-bold text-white mb-4">
              The Border Burger Co.
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
